.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(246, 247, 245, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-subtle);
  transition: padding var(--transition), box-shadow var(--transition);
}
.header.scrolled {
  box-shadow: var(--shadow-sm);
}

.bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-block: 18px;
  transition: padding var(--transition);
}
.header.scrolled .bar {
  padding-block: 11px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex: none;
}
.logo {
  height: 40px;
  width: auto;
  transition: height var(--transition);
}
.header.scrolled .logo {
  height: 32px;
}

.links {
  display: flex;
  gap: 30px;
  align-items: center;
}
.links a {
  font-size: var(--step--1);
  font-weight: 600;
  color: var(--text-secondary);
  text-decoration: none;
  transition: color var(--transition);
}
.links a:hover {
  color: var(--action);
}

.actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.menuToggle {
  display: none;
  background: none;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-sm);
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobileMenu {
  display: none;
  flex-direction: column;
  border-top: 1px solid var(--border-subtle);
  padding: 8px var(--gutter) 18px;
}
.mobileMenu a {
  padding: 12px 2px;
  font-size: var(--step-0);
  font-weight: 600;
  color: var(--text-primary);
  text-decoration: none;
  border-bottom: 1px dashed var(--border-subtle);
}
.mobileMenu.open {
  display: flex;
}

@media (max-width: 860px) {
  .links {
    display: none;
  }
  .actions .ctaButton {
    display: none;
  }
  .menuToggle {
    display: flex;
  }
}
